import { ajax } from "@utils";

export const constructionService = {
  /**
   * 取得建案登入資訊
   * @key GetConstructionLoginInfo
   * @param {string} constructionUuid - 建案uuid
   * @returns
   */
  getLoginInfo: constructionUuid => {
    return ajax
      .get(`${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/login-info`)
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  /**
   * 變更登入密碼
   * @key ForgetPasswordByProperty
   * @param {object} info - 建案登入資訊
   * @returns
   */
  changePassword: (constructionUuid, info) => {
    return ajax
      .put(`${process.env.REACT_APP_API_URL}/property/auth/forget-password`, {
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          construction_uuid: constructionUuid,
          ...info
        })
      })
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  /**
   * 取得建案資訊
   * @key GetConstructionByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @returns
   */
  get: constructionUuid => {
    return ajax
      .get(`${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}`)
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.data;
      });
  },
  /**
   * 取得建案管理費繳費方式清單
   * @key ListConstructionPaymentMethodByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @returns
   */
  getPaymentMethodList: constructionUuid => {
    return ajax
      .get(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/payment-methods/list`
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  /**
   * 儲存建案設定資訊
   * @key ConstructionSettingByProperty
   * @param {string} constructionUuid - 建案uuid
   * @param {object} info - 建案設定資訊
   * @returns
   */
  setting: (constructionUuid, info) => {
    return ajax
      .put(`${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/setting`, {
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...info
        })
      })
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  /**
   * 更新建案資訊
   * @key UpdateConstructionByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} info - 建案資訊
   * @returns
   */
  update: (constructionUuid, info) => {
    return ajax
      .put(`${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}`, {
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...info
        })
      })
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  /**
   * 取得建案住戶清單（含棟區、樓層、住戶）
   * @key ListHouseholdByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} condition - 查詢條件
   * @returns
   */
  getHouseholdList: (constructionUuid, condition) => {
    return ajax
      .get(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/households/list`,
        {
          params: {
            ...condition
          }
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  /**
   * 取得建案包裹放置清單
   * @key ListConstructionStoreAreaByProperty
   * @param {string} constructionUuid - 建案uuid
   * @returns
   */
  getStoreAreaList: constructionUuid => {
    return ajax
      .get(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/store-area/list`
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  /**
   * 取得建案摘要資訊
   * @key GetConstructionSummaryByProperty
   * @param {string} constructionUuid - 建案uuid
   * @returns
   */
  getSummaries: constructionUuid => {
    return ajax
      .get(`${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/summaries`)
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },

  /**
   * 取得建案事件資訊
   * @key GetConstructionEventByProperty
   * @param {string} constructionUuid - 建案uuid
   * @param {object} condition - 查詢條件
   * @returns
   */
  getEvents: (constructionUuid, condition) => {
    return ajax
      .get(`${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/events`, {
        params: {
          ...condition
        }
      })
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  /**
   * 取得建案住戶摘要資訊
   * @key GetConstructionHouseholdSummaryByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} condition - 查詢條件
   * @returns
   */
  getHouseholdSummaries: (constructionUuid, condition) => {
    return ajax
      .get(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/households/summaries`,
        {
          params: {
            ...condition
          }
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status === 400) {
          return Promise.reject({
            isNotFound: true,
            message: res.message
          });
        }

        if (res.status !== 200) {
          return Promise.reject({ message: res.message });
        }

        return res.data;
      });
  },
  /**
   * 取得使用者清單
   * @key ListUserByProperty
   * @param {object} condition - 查詢條件
   * @returns
   */
  getUserList: condition => {
    return ajax
      .get(`${process.env.REACT_APP_API_URL}/property/users/list`, {
        params: {
          ...condition
        }
      })
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  /**
   * 取得車位清單
   * @key ListConstructionParkingSpaceByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} condition - 查詢條件
   * @returns
   */
  getParkingSpaceList: (constructionUuid, condition) => {
    return ajax
      .get(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/parking-spaces/list`,
        {
          params: {
            ...condition
          }
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  /**
   * 搜尋建案目標資訊
   * @key GetConstructionTargetByProperty
   * @param {string} constructionUuid - 建案uuid
   * @param {object} condition - 查詢條件
   * @returns
   */
  searchTarget: (constructionUuid, condition) => {
    return ajax
      .get(`${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/target`, {
        params: {
          ...condition
        }
      })
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  /**
   * 取得物業操作選項清單
   * @key ListOperateOptionByProperty
   * @param {string} type - 操作類型
   * @returns
   */
  getOperateOptionList: type => {
    return ajax
      .get(`${process.env.REACT_APP_API_URL}/property/operate-options/list`, {
        params: {
          type
        }
      })
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  getParkingSpacePatternList: () => {
    return ajax
      .get(`${process.env.REACT_APP_API_URL}/property/parking-space-patterns/list`)
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  }
};
